import React from "react";
import { useQuery } from "@apollo/client";
import DtsReactTable from "../../reuseableComponents/dtsReactTable/DtsReactTable";
import { frequencyType, sampleType } from "../../../utilities/constants/WaterSystemConstants";
import { GET_PUBLIC_BACTERIOLOGICAL_MONITORING } from "../../../queries/archiveQrys/MonitoringScheduleReportQueries";
import { convertTimeStampToDate } from "./../../../utilities/commonFunctions/timeConversionFunctions";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";

const BacteriologicalMonitoringTable = (props) => {
  const { systemId } = props;

  const columns = [
    {
      Header: "Sample Count",
      accessor: "samplesRequired"
    },
    {
      Header: "Type",
      accessor: (d) => {
        return d.sampleType ? sampleType[d.sampleType] : "";
      }
    },
    {
      Header: "Frequency",
      accessor: (d) => {
        return d.frequency ? frequencyType[d.frequency] : "";
      }
    },
    {
      Header: "Schedule Begin",
      accessor: (d) => {
        return d.scheduleBeginDate ? convertTimeStampToDate(d.scheduleBeginDate) : "";
      }
    },
    {
      Header: "Schedule End",
      accessor: (d) => {
        return d.scheduleEndDate ? convertTimeStampToDate(d.scheduleEndDate) : "";
      }
    },
    {
      Header: "Analyte Name",
      accessor: "analyteName"
    }
  ];

  const { loading, error, data } = useQuery(GET_PUBLIC_BACTERIOLOGICAL_MONITORING, { variables: { systemId } });

  if (loading) return <SkeletonLoader width='100%' />;
  if (error) return <ErrorHandler error={error} />;

  let array = [];
  if (data.getPublicBacteriologicalMonitoring !== null) {
    array.push(data.getPublicBacteriologicalMonitoring);
  }

  return (
    <>
      {array.length > 0 ? (
        <DtsReactTable data={array} columns={columns} headerColor='ddw' />
      ) : (
        <span>No bacteriological monitoring data was found in the database.</span>
      )}
    </>
  );
};

export default BacteriologicalMonitoringTable;
